import cn from '@/lib/clsxm';

import Card from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import XImage from '@/components/@base/x-image';
import PriceView from '@/components/shared/components/price-view';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';
import ProductModel from '@/models/product.model';
import Link from 'next/link';

export default function BestSellerProductCard({ product }: { product: ProductModel }) {
  const { store: storeLocalization } = pageLevelLocalization;

  return (
    <Card
      noShadow
      noBorder
      className='flex flex-row bg-[#D9D9D9] bg-opacity-20 lg:grid lg:grid-cols-2 '
    >
      <Container className='flex flex-1 flex-col  justify-center gap-5  p-6'>
        <Container className='flex flex-row gap-2'>
          <XImage alt='fireIcon' width={14} height={18} src={imagesList.icons.fireIcon} />
          <Text className='text-[13px] font-light tracking-tight text-[#FF9C33] lg:text-[15px]'>
            {storeLocalization.best_seller_product}
          </Text>
        </Container>
        <Heading
          type={HEADING_TYPE.H3}
          className='text-[15px] font-medium leading-8 tracking-tighter text-[#404040] lg:text-[17px]'
        >
          <Link href={`/web/${product?.slug}`} className='hover:text-[#ff9606]' prefetch={false}>
            {product?.title}
          </Link>

        </Heading>
        <Container>
          <PriceView
            sellable={product.sellable}
            price={product.price}
            lastPrice={product.lastPrice}
            discount={product.discount}
            saleEndedAt={product.saleEndedAt}
            priceClassName='text-[18px] font-medium text-[#4D4A4A] leading-6'
            currencyClassName='font-light text-[13px] text-[#8C8C8C]'
            lastPriceClassName='font-medium text-[16px] text-[#B1B1B1] line-through leading-9'
          />
        </Container>
      </Container>
      <Container className='relative m-[10px] hidden  justify-end md:flex '>
        <XImage
          className={cn('rounded-md ')}
          width={266}
          height={239}
          alt={product?.cover?.title || ''}
          src={product?.cover?.publicLink || ''}
        />
      </Container>
      <Container className='relative m-5  md:hidden '>
        <XImage
          className={cn('rounded-md object-center')}
          width={85}
          height={100}
          alt={product?.icon?.title || ''}
          src={product?.icon?.publicLink || ''}
        />
      </Container>
    </Card>
  );
}
